import { Component, OnInit, Input, ViewChild, TemplateRef, ContentChild, Output, EventEmitter, Renderer2, AfterViewInit } from '@angular/core';
import * as _ from 'lodash';
import { MultiSelect } from 'primeng/multiselect'
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mapfre-auditlib-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {

  @ContentChild('selectedItemsTemplate', { static: false }) selectedItemsTemplate: TemplateRef<any>;
  @ContentChild('itemTemplate', { static: false }) itemTemplate: TemplateRef<any>;

  _form;
  model;
  isConverted: boolean = false;
  tempForm: UntypedFormControl = new UntypedFormControl(null, []);
  unsubscribeForm;
  stopPropagation;
  originalForm;
  originalModel;

  @Input() field;
  @Input() noItemsPlaceholder: boolean = false;
  @Input() label;
  @Input() icon;
  @Input() placeholder;
  @Input() disabled: boolean;
  @Input() selectionMode;
  @Input() readonly: boolean;
  @Input() appendTo;
  @Input() showToggleAll = true;
  @Input() overlayVisible = false;
  @Input() noInput = false;
  @Input() maxSelectedLabels = 3;
  @Input() skipHighlighter = false;
  @Input() virtualScroll = true;
  @Input() sort = true;
  @Input() order = 1;
  @ViewChild('simple', { static: false }) simple: MultiSelect;
  @ViewChild('multiple') multiple: MultiSelect;
  @Output() onChange = new EventEmitter();
  @Output() onHide = new EventEmitter();
  @Output() onClick = new EventEmitter();
  get form() {
    return this._form;
  }

  @Input('form')
  set form(form) {
    if (form) {
      this._form = form;
      this.originalForm = form;
      this.form.valueChanges.subscribe((newValue) => {
        this.onModelChange(newValue, true);
      });

    }
  }
  _data
  @Input()
  set data(value) {
    this._data = value;
    if (this.sort) {
      this.orderOptions();
    }
    this._data = this.getItemOrderedBySelection();
  }
  get data() {
    return this._data;
  }

  constructor(private translateService: TranslateService, private renderer: Renderer2) {
    this.form = new UntypedFormControl(null, [])
    this.translateService.onLangChange.subscribe(res => {
      this.translateOptions();
    })
    this.translateService.onTranslationChange.subscribe(res => {
      this.translateOptions();
    })
  }

  stopPropagationEvent(event) {
  }

  onPanelHide() {
    this.renderer.removeClass(document.body, 'select-open');
    if (this.overlayVisible) {
      if (this.multiple) {
        this.multiple.overlayVisible = true;
      }
      else {
        this.simple.overlayVisible = true;
      }
    }
    this._data = this.getItemOrderedBySelection();
    this.onHide.emit();
  }

  clicked(event) {
    this.onClick.emit(event);
  }

  getItemOrderedBySelection() {
    if (_.get(this.data, '[0]')) {
      let idProp: any = _.find(_.keysIn(_.get(this.data, '[0]')), (prop) => { return _.findIndex(prop, 'id') });
      let ids;
      if (_.isArray(this._form.value)) {
        ids = _.map(this._form.value, (user) => _.get(user, idProp));
      }
      else {
        ids = [_.get(this.form.value, idProp)];
      }
      return _.orderBy(this.data, (item) => _.find(ids, (id) => id === _.get(item, idProp)));
    }
    return this.data;
  }

  ngOnInit() {
    this.selectionMode = this.selectionMode || 'multiple';
    if (this.selectionMode === 'simple' && this.form) {
      this.onModelChange(this.form.value, false);
    }
  }

  onPanelShow() {
    if(this.disabled){
      this._data = this.getItemOrderedBySelection();
    }
    if (this.readonly) {
      let instance;
      if (this.multiple) {
        instance = this.multiple;
      }
      else {
        instance = this.simple;
      }

      instance.disabledSelectedOptions = this.data;
      instance.optionDisabled = instance.optionLabel;
      setTimeout(() => {

        //Add layer to avoid events
        const html = '<div class="p-overlay"></div>';
        _.forEach(instance.overlay?.getElementsByClassName('p-multiselect-item'), it => {
          it.classList.add('position-relative');
          it.insertAdjacentHTML('afterbegin', html);
        });

        _.forEach(instance.overlay?.getElementsByClassName('p-checkbox-box'), it => {
          it.classList.add('p-state-disabled');
          it.classList.remove('p-state-active');
          it.addEventListener('click', (event) => {
            event.stopPropagation();
          })
        });

        _.forEach(instance.overlay?.getElementsByClassName('p-overlay'), it => {
          it.addEventListener('click', (event) => {
            event.stopPropagation();
          })
        });

        _.forEach(instance.overlay?.getElementsByTagName('span'), it => it.addEventListener('click', (event) => {
          event.stopPropagation();
        }))

        _.forEach(instance.overlay?.getElementsByClassName('p-multiselect-item'), it => it.addEventListener('click', (event) => {
          event.stopPropagation();
        }));
      }, 0)
    }
    //this.renderer.addClass(document.body, 'select-open');
  }


  optionDisabled(disabled) {
    if (disabled) {
      disabled.stopPropagation();
    }
  }

  onModelChange(newValue, isSubscribe) {
    if (newValue !== null && newValue !== undefined) {
      this.model = _.isArray(newValue) ? _.last(newValue) ? [_.last(newValue)] : newValue : [newValue];
      this.originalModel = this.model;
      if (!isSubscribe) {
        this.form.setValue(_.head(this.model));
      }
    } else {
      this.model = null;
      if (!isSubscribe) {
        this.form.setValue(null)
      }
    }
    if (this.simple) {
      setTimeout(() => this.simple.hide()
      )
    };

  }

  onChangeHandler(event) {
    this.form.markAsTouched();
    if (this.selectionMode === 'simple') {
      if (event.value.length === 0) {
        this.onChange.emit([]);
      }
      else {
        this.onChange.emit({ value: [event.itemValue], itemValue: event.itemValue });
      }
    }
    else {
      this.onChange.emit(event);
    }
  }

  translateOptions() {
    let refreshData = [];
    _.forEach(this.data, (d, i) => {
      refreshData.push(d);
    })
    this.data = refreshData;
  }

  orderOptions() {
    this._data = this.order === 1 ? _.sortBy(this._data, this.field) : _.reverse(_.sortBy(this._data, this.field));
  }

}